var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 44,
    viewBox: "0 0 17 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_584_8670",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 17,
    height: 44
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.312243 43.6914H16.4482L16.4482 0.782806H0.312243L0.312243 43.6914Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_584_8670)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.0093 18.5587L4.19328 33.5777C3.90728 34.2087 3.90728 35.2317 4.19328 35.8627C4.48028 36.4937 4.94428 36.4937 5.23128 35.8627L12.5653 19.7017C12.7033 19.3987 12.7803 18.9877 12.7803 18.5587C12.7803 18.1307 12.7033 17.7197 12.5653 17.4167L5.23128 1.25667C5.08728 0.940668 4.90028 0.782669 4.71228 0.782669C4.52428 0.782669 4.33728 0.940668 4.19328 1.25667C3.90728 1.88767 3.90728 2.9107 4.19328 3.5417L11.0093 18.5587Z",
    stroke: "#916DE1",
    strokeWidth: 3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRight);
export default __webpack_public_path__ + "static/media/Right.7b979792d86a659a3c1fe4bbed868215.svg";
export { ForwardRef as ReactComponent };